import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPencil = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.4396 7.98879L12.2611 6.81027L4.49967 14.5717V15.7502H5.67818L13.4396 7.98879ZM14.6181 6.81027L15.7966 5.63176L14.6181 4.45325L13.4396 5.63176L14.6181 6.81027ZM6.36854 17.4169H2.83301V13.8814L14.0288 2.68549C14.3543 2.36005 14.8819 2.36005 15.2073 2.68549L17.5644 5.0425C17.8898 5.36795 17.8898 5.89558 17.5644 6.22102L6.36854 17.4169Z",
		fill: "#03314B"
	})
});
export default SvgIconPencil;
